import { getDateFieldFormSchema } from '@common';
import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import z from 'zod';
import { getInitialVersionValue } from './helpers';

const TRANS_KEY = 'VERSION_SELECT.EDIT_VERSION_MODAL.VERSION_ERRORS';

const buildVersionFormSchema = (t: TFunction) =>
  z.object({
    version: getDateFieldFormSchema({
      invalidFormatMessage: t(`${TRANS_KEY}.INVALID_FORMAT`),
      invalidDateMessage: t(`${TRANS_KEY}.INVALID_DATE`),
    }),
  });

type VersionFormSchemaType = ReturnType<typeof buildVersionFormSchema>;
export type VersionFormDataType = z.infer<VersionFormSchemaType>;

type UseVersionFormSchemaReturnType = {
  schema: VersionFormSchemaType;
  defaultValues: VersionFormDataType;
};

export const useVersionFormSchema = (
  initialVersion: string
): UseVersionFormSchemaReturnType => {
  const { t } = useTranslation();

  const schema = buildVersionFormSchema(t);

  const defaultValues: VersionFormDataType = {
    version: getInitialVersionValue(initialVersion),
  };

  return {
    schema,
    defaultValues,
  };
};
